<template lang="pug">
v-container.pa-8(fluid)
  v-row.mb-2(no-gutters align="center")
    v-col.shrink
      v-btn.ml-n3(text icon @click="goBack" height)
        v-icon(color="neutral700" :size="24") mdi-arrow-left
    v-col.ml-3
      .text-2xl.font-semibold.neutral700--text Users
  v-row.pb-2.pb-md-0(no-gutters)
    v-col(cols="12" md="8")
      v-tabs(v-model="tabs" color="basic700" :height="44" :grow="isMobileScreen")
        v-tab.text-sm.font-semibold.text-none.px-4 {{ $t('all') }}
        v-tab.text-sm.font-semibold.text-none.px-4 Admin
        v-tab.text-sm.font-semibold.text-none.px-4 Clinic assistant
        v-tab.text-sm.font-semibold.text-none.px-4 Doctor
    v-col(cols="12" md="4" align="end")
      .d-flex.align-center
        v-spacer
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
        div
          customize-column-menu(type="user" :showTooltip="false" iconSize="21")
        v-btn.button-sm.ml-4(color="neutral700" dark depressed @click="addNewUser") Add new
  v-divider

  .data-table
    v-data-table.table-custom.mt-sm-4.pb-6(:headers="headers" :items="users" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }")
      //- name
      template(v-slot:item.name="{ item, index }")
        div.d-flex.align-center.my-3(style="max-width: 200px;")
          div(style="width: 30px;")
            template(v-if="item.roles.includes('Agent')")
              v-responsive(:aspect-ratio="7/10" style="width: 30px;")
                v-card.fill-height(v-if="item.profile_image && item.profile_image.file" flat)
                  v-img(:src="`https://img.yezza.io/50x50/${item.profile_image.path}`" height="100%" width="100%")
                    template(v-slot:placeholder)
                      v-row(class="fill-height ma-0" align="center" justify="center")
                        v-progress-circular(indeterminate color="grey")
                v-card.neutral300.fill-height(v-else flat)
                  div.d-flex.align-center.justify-center.fill-height
                    v-icon(size="20") $yzi-user-03
            intel-avatar(v-else :code="item.user.avatar_code" :id="item.user.id" size="30")
          div.pl-2
            div(:id="`pt-${index}`" style="position: relative;")
            v-tooltip(top color="neutral700" :attach="`#pt-${index}`")
              template(#activator="{ on, attrs }")
                div(v-bind="attrs" v-on="on" style="max-width: 145px;")
                  .text-sm.font-semibold.neutral700--text.cursor-help.truncate {{ item.user.first_name + (item.user.last_name ? ` ${item.user.last_name}` : '' ) }}
                  .text-xs.neutral700--text.cursor-help.truncate {{ item.user.email }}
              div(style="max-width: 500px;")
                .text-sm.font-semibold {{ item.user.first_name + (item.user.last_name ? ` ${item.user.last_name}` : '' ) }}
                .text-xs {{ item.user.email }}
      //- role
      template(v-slot:item.role="{ item }")
        div(style="max-width: 185px")
          .text-sm.neutral700--text.capitalize {{ getRoles(item.roles) }}
      //- service
      template(v-slot:item.service="{ item, index }")
        div(:id="`sv-${index}`" style="position: relative;")
        div.d-flex.align-center(v-if="item.roles.includes('Agent') && item.services")
          template(v-for="svarray in filteredServices(item.services)")
            y-chip(:label="svarray.length < 25 ? svarray : `${svarray.substr(0, 25)}...`" size="sm" chip-class="pa-1 mr-2" :key="svarray.id" outlined)
          v-tooltip(v-if="item.services.length !== filteredServices(item.services).length" :attach="`#sv-${index}`" top color="neutral700")
            template(#activator="{ on, attrs }")
              div(v-bind="attrs" v-on="on")
                y-chip.cursor-help(:label="`+${item.services.length - filteredServices(item.services).length} more`" size="sm" chip-class="pa-1" outlined)
            div
              div(v-for="(service, index) in item.services" :key="service.id") {{ index + 1 }}. {{ service }}
      //- availability
      template(v-slot:item.availability="{ item, index }")
        div(:id="`av-${index}`" style="position: relative;")
        template(v-if="item.roles.includes('Agent') && item.schedules")
          v-tooltip(top color="neutral700" :attach="`#av-${index}`")
            template(#activator="{ on, attrs }")
              div.d-flex.align-center.cursor-help(v-bind="attrs" v-on="on")
                template(v-for="scharray in filteredSchedules(item.schedules)")
                  y-chip(:label="scharray.day" size="sm" chip-class="pa-1 mr-2" :key="scharray.day" outlined)
                template(v-if="item.schedules.filter(f => f.slots.length > 0).length !== filteredSchedules(item.schedules).length")
                  y-chip(:label="`+${item.schedules.filter(f => f.slots.length > 0).length - filteredSchedules(item.schedules).length} more`" size="sm" chip-class="pa-1" outlined)
            div(style="max-width: 500px;")
              template(v-for="scharray in filteredSchedules(item.schedules)")
                .text-sm.font-semibold {{ scharray.day }}:
                template(v-for="slot in scharray.slots")
                  .text-xs(:key="slot.id" ) {{ slot.begin | displayTime2 }} - {{ slot.end | displayTime2 }}
      //- overrides
      template(v-slot:item.overrides="{ item }")
        template(v-if="item.roles.includes('Agent')")
          y-chip(v-if="item.with_overrides" label="Overrides" color="green")
            template(#prepend)
              v-icon.mr-1(size="12" color="success600") mdi-record
          y-chip(v-else label="No overrides" color="red")
            template(#prepend)
              v-icon.mr-1(size="12" color="danger600") mdi-record
      //- status
      template(v-slot:item.status="{ item }")
        div
          y-switch.mb-n3.ml-n3(v-model="item.enabled" @change="updateStatus(item, item.enabled)")
      //- actions
      template(v-slot:item.actions="{ item, index }")
        v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
          template(#activator="{ on }")
            v-btn(icon small v-on="on")
              v-icon mdi-dots-horizontal
          v-list.py-0
            v-list-item(@click="editUser(item)")
              v-list-item-title.text-sm.basic800--text Edit user
            v-divider
            v-list-item(v-if="item.id === company.primary_owner")
              v-list-item-title.text-sm.neutral500--text Delete user
            v-list-item(v-else @click="deleteUser(item)")
              v-list-item-title.text-sm.danger500--text Delete user

  div.d-flex.align-center(v-if="totalCount > pageSize")
    v-spacer
    yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

  .dialogs
    delete-confirmation-dialog(v-if="openDeleteDialog" :open.sync="openDeleteDialog" :loading="isLoading" @cancel="closed" @delete="confirmDelete")
      .text-lg.font-medium Are you sure you want to delete this user?
      .text-md.mt-4 This action will be done immediately and can’t be undone. Click “Confirm” to proceed

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'
import IntelAvatar from '@/components/IntelAvatar.vue'

export default {
  name: 'Users',
  components: { CustomizeColumnMenu, DeleteConfirmationDialog, IntelAvatar },
  data: () => ({
    isFetching: false,
    isLoading: false,
    openDeleteDialog: false,
    showSearchField: false,
    searchText: null,
    tabs: 0,
    selectedUser: null,
    pageSize: 20,
    totalCount: 0,
    currentPage: 1,
    users: []
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      userFields: 'clinic/getUserFields'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    headers () {
      const name = { text: 'Name', value: 'name', enable: true, width: '232px' }
      const fields = this.userFields.filter(item => item.enable)
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
      })
      const actions = {
        text: '',
        value: 'actions',
        enable: true,
        sortable: false
      }
      return [name, ...fields, actions]
    },
  },
  watch: {
    tabs () {
      this.searchText = null
      this.currentPage = 1
      this.fetchUserList()
    },
    pageSize () {
      this.currentPage = 1
      this.fetchUserList()
    }
  },
  mounted () {
    this.headers.map(item => item['class'] = 'text-table-header')
    this.fetchUserList()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchUserList () {
      this.isFetching = true
      let params = {
        page_size: this.pageSize,
        page: this.currentPage
      }
      if (this.tabs !== 0) { params.role = this.tabs }
      if (this.searchText) { params.search = this.searchText }
      this.$axios.get(`/clinics/${this.company.slug}/members`, { params })
        .then(resp => {
          let users = resp.data.results
          users.map(m => m.enabled = m.status === 'active')
          this.users = users
          this.totalCount = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    updateStatus (item, status) {
      this.isFetching = true
      this.$axios.patch(`/clinics/${this.company.slug}/members/${item.id}`, { status: status ? 'active' : 'inactive' })
        .then(() => {
          this.fetchUserList()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.isFetching = false
        })
    },
    confirmDelete () {
      this.isLoading = true
      this.$axios.delete(`/clinics/${this.company.slug}/members/${this.selectedUser.id}`)
        .then(() => {
          this.reset()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    queryChanged: debounce(function () {
      this.currentPage = 1
      this.fetchUserList()
    }, 750),
    pageChanged () {
      this.fetchUserList()
    },
    filteredServices (arrays) {
      if (arrays.length > 1) {
        let newArray = []
        let count = 0
        arrays.forEach((o, idx) => {
          count += o.length
          if (idx === 0 || count <= 25) {
            newArray.push(o)
          }
        })
        return newArray
      }
      return arrays
    },
    filteredSchedules (arrays) {
      if (arrays.length > 1) {
        let newArray = []
        let count = 0
        arrays.filter(f => f.slots.length > 0).forEach((o, idx) => {
          count += o.day.length
          if (idx === 0 || count <= 9) {
            newArray.push(o)
          }
        })
        return newArray
      }
      return arrays
    },
    getRoles (roles) {
      return roles.map(m => this.getClinicRole(m)).join(', ')
    },
    getClinicRole (role) {
      switch (role) {
        case 'Admin':
          return 'Admin'
        case 'Salesperson':
          return 'Clinic Assistance'
        case 'Agent':
          return 'Doctor'
        case 'Bookkeeper':
          return 'Finance'
        default:
          return role
      }
    },
    deleteUser (item) {
      this.selectedUser = item
      this.openDeleteDialog = true
    },
    reset () {
      this.currentPage = 1
      this.fetchUserList()
      this.closed()
    },
    closed () {
      this.selectedUser = null
      this.openDeleteDialog = false
    },
    addNewUser () {
      this.$router.push('/admin/clinic/user')
    },
    editUser (item) {
      this.$router.push(`/admin/clinic/user/${item.id}`)
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.users.length - 2
        if (position > start) {
          return true
        }
      }
      return false
    },
  }
}
</script>

<style lang="scss" scoped>
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.v-tooltip__content {
  top: unset !important;
  left: unset !important;
  // margin-top: -45px !important;
  position: absolute;
  bottom: 0;
}
::v-deep {
  .table-custom {
    .v-data-table__wrapper {
      overflow: visible !important;
    }
  } 
}
</style>